var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_1_2",
    "data-name": "Componente 1 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 261.989,
    height: 64.265,
    viewBox: "0 0 261.989 64.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_96",
    "data-name": "Rect\\xE1ngulo 96",
    width: 261.989,
    height: 64.265,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_197",
    "data-name": "Grupo 197",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    "data-name": "Trazado 109",
    d: "M132.658,32.94c0,4.917-3.553,8.416-8.832,8.416a9.346,9.346,0,1,1-.153-18.687,9.037,9.037,0,0,1,7.85,4.273l-2.546,1.468a6,6,0,0,0-5.3-2.858,6.289,6.289,0,0,0-6.486,6.489,6.293,6.293,0,0,0,6.666,6.432c3.268,0,5.278-1.7,5.819-4.118h-6.025V31.7h9.011Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    "data-name": "Trazado 110",
    d: "M141.925,27.922v3.009c-1.829-.126-3.964.723-3.964,3.606v6.486h-2.78V28.152h2.78v2.163a4.046,4.046,0,0,1,3.964-2.393",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    "data-name": "Trazado 111",
    d: "M155.44,28.152V41.023h-2.782V39.375a4.425,4.425,0,0,1-3.989,1.981c-2.883,0-4.943-1.955-4.943-5.3v-7.9h2.78v7.62a2.684,2.684,0,0,0,2.883,2.987c1.829,0,3.269-1.082,3.269-3.709v-6.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112",
    "data-name": "Trazado 112",
    d: "M172.379,34.587a6.56,6.56,0,0,1-6.41,6.769,5.342,5.342,0,0,1-4.5-2.16v6.976h-2.779V28.152h2.779v1.854a5.292,5.292,0,0,1,4.5-2.188,6.576,6.576,0,0,1,6.41,6.769m-2.779,0a4.068,4.068,0,1,0-4.068,4.118,3.978,3.978,0,0,0,4.068-4.118",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113",
    "data-name": "Trazado 113",
    d: "M174.18,34.587a6.8,6.8,0,1,1,6.8,6.769,6.718,6.718,0,0,1-6.8-6.769m10.812,0a4.015,4.015,0,1,0-4.015,4.068,3.952,3.952,0,0,0,4.015-4.068",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_114",
    "data-name": "Trazado 114",
    d: "M207.722,41.023h-2.961V28.177l-5.481,9.061h-.361l-5.483-9.086V41.023h-2.961V23h3.194l5.43,9.008L204.556,23h3.166Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_115",
    "data-name": "Trazado 115",
    d: "M210.427,34.587a6.8,6.8,0,1,1,6.795,6.769,6.718,6.718,0,0,1-6.795-6.769m10.812,0a4.016,4.016,0,1,0-4.017,4.068,3.952,3.952,0,0,0,4.017-4.068",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_116",
    "data-name": "Trazado 116",
    d: "M238,28.152V41.023h-2.779V39.375a4.429,4.429,0,0,1-3.99,1.981c-2.883,0-4.942-1.955-4.942-5.3v-7.9h2.779v7.62a2.683,2.683,0,0,0,2.883,2.987c1.827,0,3.27-1.082,3.27-3.709v-6.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_117",
    "data-name": "Trazado 117",
    d: "M247.987,27.922v3.009c-1.829-.126-3.964.723-3.964,3.606v6.486h-2.78V28.152h2.78v2.163a4.046,4.046,0,0,1,3.964-2.393",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_118",
    "data-name": "Trazado 118",
    d: "M255.761,38.809a3.928,3.928,0,0,0,3.32-1.6l2.289,1.339a6.494,6.494,0,0,1-5.637,2.8c-4.247,0-7-2.908-7-6.769a6.563,6.563,0,0,1,6.8-6.768,6.493,6.493,0,0,1,6.461,6.794,8.212,8.212,0,0,1-.1,1.159H251.642a3.87,3.87,0,0,0,4.119,3.037m3.421-5.3A3.579,3.579,0,0,0,255.5,30.34a3.741,3.741,0,0,0-3.888,3.166Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_119",
    "data-name": "Trazado 119",
    d: "M108.088,64.265H72.508a1.348,1.348,0,0,1-1.165-.672l-16.628-28.8L38.09,63.593a1.348,1.348,0,0,1-1.165.672H1.345A1.344,1.344,0,0,1,.18,62.249L35.761.621a1.4,1.4,0,0,1,2.329,0l16.625,28.8L71.343.621a1.4,1.4,0,0,1,2.33,0l35.58,61.628a1.344,1.344,0,0,1-1.165,2.016m-34.8-2.688h32.477L72.508,3.982,56.269,32.109Zm-69.612,0H36.15L53.164,32.109,36.925,3.982Z",
    fill: "#ef6a20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2938bcb08e47285afa0e31117069f7ab.svg";
export { ForwardRef as ReactComponent };